import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardText, CardHeader } from 'material-ui/Card';
import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';

import ModuleIcon from 'material-ui/svg-icons/action/view-module';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import SpotIcon from 'material-ui/svg-icons/image/lens';

import BasicProgressBar from '../ProgressBar/BasicProgressBar';
import { capitalise } from '../../utils/StringUtils';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar/dist/index';
import 'react-circular-progressbar/dist/styles.css';


const progressSection = (label, data, link) => (
    <div key={label}>
        <BasicProgressBar {...data} link={link}/>
        <p className="progressBar-label">
            {(label === 'optional' || label === 'mandatory' ) && (<SpotIcon className="icon-small" color={statusColours[label]} key={label}/>)}
            {capitalise(label)} {data.completed}/{data.total}
        </p>
    </div>
);

const parseEnrolments = (rawData) => {
    if (!rawData) { return {}; }

    let enrolments = {
        total: 0,
        completed: 0,
    };

    rawData.forEach(stat => {
        const total = Number(stat.total);
        const completed = Number(stat.completed);

        const data = {
            total,
            completed,
            enrolled: Number(stat.enrolled),
            waiting: Number(stat.waiting),
            cancelled: 0,
        };
        enrolments.total += total;
        enrolments.completed += completed;

        if (!stat.isAssigned) {
            enrolments.booked = data;
        } else if (stat.isMandatory) {
            enrolments.mandatory = data;
        } else {
            enrolments.optional = data;
        }
    });

    return enrolments;
};

const labels = ['mandatory', 'optional', 'booked'];
const MyTrainingWidget = ({courseEnrolments, moduleEnrolments, resourceEnrolments}) => {
    const sections = {
        courses: parseEnrolments(courseEnrolments), // this would replace the default values
        modules: parseEnrolments(),
        resources: parseEnrolments(resourceEnrolments),
    };

    const iconProps = {
        color: statusColours.default,
    };

    const configs = {
        courses: {
            title: 'Enrolments and assignments',
            subtitle: 'Enrolments',
            icon: <SchoolIcon {...iconProps} />
        },
        modules: {
            title: '',
            subtitle: 'Enrolments',
            icon: <ModuleIcon {...iconProps} />,
        },
        resources: {
            title: '',
            subtitle: 'Assignments',
            icon: <LibraryIcon {...iconProps} />,
        },

    };


    return (
        <div className="cent-flex-row">
            {Object.keys(sections)
                .filter(section => sections[section] && sections[section].total)
                .map(section => (

                    <Card
                        key={section}
                        className="cent-card cent-card-6"
                        initiallyExpanded={true}
                    >
                        <CardHeader
                            title={<Link to={`/dashboard/mytraining/${section}`} >My {section}</Link>}
                            subtitle={`${sections[section].total} ${configs[section].subtitle}`}
                            avatar={<Link to={`/dashboard/mytraining/${section}`} >{configs[section].icon}</Link>}
                        />
                        <CardText className="cent-zero">
                            <div className="cent-content">
                                <div className="content-left">
                                    <div className={'cent-progress-bar-circular'}>
                                        <a className="a-block" href={`/dashboard/mytraining/${section}`}>
                                            <CircularProgressbar
                                                strokeWidth={12}
                                                value={sections[section].completed}
                                                maxValue={sections[section].total}
                                                text={`${Math.round((sections[section].completed / sections[section].total) *100)}%`}
                                                styles={buildStyles({
                                                    rotation: 0.25,
                                                    strokeLinecap: 'butt',
                                                    textSize: '18px',
                                                    pathTransitionDuration: 0.5,
                                                    pathColor: statusColours.primary,
                                                    textColor: statusColours.default,
                                                    trailColor: statusColours.disabled,
                                                    backgroundColor: statusColours.primary_2,
                                                })}
                                            />
                                        </a>
                                    </div>
                                </div>
                                <div className="content-main">
                                    {labels
                                        .filter(label => !!sections[section][label])
                                        .map((label) => progressSection(label, sections[section][label], `/dashboard/mytraining/${section}`))
                                    }
                                </div>
                            </div>
                        </CardText>
                    </Card>
                ))
            }
        </div>
    );
};

MyTrainingWidget.propTypes = {
    courseEnrolments:     PropTypes.array.isRequired,
    resourceEnrolments:   PropTypes.array,
};

export default MyTrainingWidget;
